import * as z from "zod/v4";

const HsCodeItemSchema_ = z.object({
  id: z.string(),
  code: z.string(),
  description: z.string(),
  hasChildren: z.boolean(),
});

export const HsCodeItemSchema: z.ZodType<HsCodeItem> = HsCodeItemSchema_;
export interface HsCodeItem extends z.infer<typeof HsCodeItemSchema_> {}

export const getHsCodes = {
  name: "getHsCodes" as const,
  input: z.object({
    parentId: z.string().optional(),
  }),
  output: z.object({
    items: z.array(HsCodeItemSchema),
  }),
};
